import { Component, Inject, OnInit } from '@angular/core';
import { LocalizationService } from 'src/core/utilitites/localization.service';
import { environment } from 'src/environments/environment';
export enum EOnetimeWizardSuccessParamAction {
    CLICK = 'click',
    SESSION_EXPIRE = 'session',
}
import {
    MsalGuardConfiguration,
    MsalService,
    MSAL_GUARD_CONFIG,
} from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';
import { UserProfileObject, UserService } from 'merlin-library';

@Component({
    selector: 'one-time-wizard-success',
    templateUrl: './one-time-wizard-success.component.html',
    styleUrls: ['./one-time-wizard-success.component.scss'],
    standalone: false
})
export class OneTimeWizardSuccessComponent implements OnInit {
    currentYear: any = new Date().getFullYear();
    footerCopyRights: any = [
        { linkText: `Merlin.net\u2122 \u00A9 ${this.currentYear} Abbott` },
    ];
    idleState = 'NOT_STARTED';
    msgStr: string;
    fooMenuClass = '';
    footerData: any = [
        {
            url: '/terms-of-use',
            link: 'label.gb.terms_cond',
            clickFunction: this.websiteTermsClick,
        },
        {
            url: '/privacy-policy',
            link: 'label.gb.priv_policy',
            clickFunction: this.privacyPolicyClick,
            showClick: true,
        },
        {
            url: '/contact-us',
            link: 'label.gb.contact_us',
            clickFunction: this.contactUsClick,
        },
        {
            url: '/cardio-vascular',
            link: 'www.cardiovascular.abbott',
            clickFunction: this.websiteMoreInfoClick,
            showClick: true,
        },
    ];
    constructor(
        private msalService: MsalService,
        private localizationService: LocalizationService,
        @Inject(MSAL_GUARD_CONFIG)
        private msalGuardConfig: MsalGuardConfiguration,
        private userService: UserService,
    ) {}
    translate(key: string): any {
        return this.localizationService.generateLocalizedStr(key, '', 'html');
    }
    ngOnInit(): void {
        this.getUserProfile();
        
    }
    doLogout() {
        if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
            this.msalService.logoutPopup({
                postLogoutRedirectUri: environment.redirectUri,
                mainWindowRedirectUri: environment.redirectUri,
            });
        } else {
            if (this.idleState === 'NOT_STARTED' || this.idleState === 'NOT_IDLE') {
                // Manual Signout
                this.msalService.logoutRedirect({
                    postLogoutRedirectUri: this.isImpersonatedUser()
                        ? environment.logoutRedirectURI
                        : environment.redirectUri,
                });
            } else {
                //Session timeout
                this.msgStr = this.localizationService.generateLocalizedStr(
                    'msg.cs817.text',
                    'html'
                );

                let strfy = JSON.stringify({
                    impersonated: this.isImpersonatedUser(),
                    message: this.msgStr,
                    btnLabel: `${this.localizationService.generateLocalizedStr(
                        'label.gb.ok'
                    )}`,
                });
                let encodeURICmp = window.encodeURIComponent(strfy);
                this.msalService.logoutRedirect({
                    postLogoutRedirectUri: this.isImpersonatedUser()
                        ? environment.logoutRedirectURI
                        : environment.forceLogoutURI +
                        '?params=' +
                        window.btoa(encodeURICmp),
                });
            }
            /***
             * Reset Primary & Secondary filters
             *  to Default in both RT & patient List page
             */
            // const gridConfig = window.sessionStorage.gridArrayStore; // Enable this if want to revert

            window.sessionStorage.clear();
            // let gridConfigPrse = JSON.parse(gridConfig)?.filter(   // Enable this if want to revert
            //     (d) => d.gridName != 'patient-grid'
            // );
            // window.sessionStorage.gridArrayStore =
            //     JSON.stringify(gridConfigPrse);
            /**--------------------------- */
            this.userService.setRoleObs(null);
            this.userService.logoutUser$.next(true);
        }
    }
    isImpersonatedUser() {
        return (
            this.userProfile?.effectiveUserRecordId > 0 &&
            this.userProfile.userRecordId == 0
        );
    }
    userProfile: UserProfileObject | any;
    getUserProfile() {
        this.userService.getUserProfile(false).subscribe((userinfo: any) => {
            this.userProfile = {
                ...userinfo,
            };
        });
    }
    //footer links
    websiteTermsClick() {
        window.open(
            environment.disclosureUrl + '/Terms_and_Conditions.pdf',
            '_blank'
        );
    }

    privacyPolicyClick() {
        window.open(
            environment.disclosureUrl + '/Privacy_Policy.pdf',
            '_blank'
        );
    }
    contactUsClick() {
        const title = 'Contact Information';
        var win = window.open(
            '',
            'UATRpt',
            'menubar=0,location=0,toolbar=0,resizable=1,status=1,scrollbars=1'
        );

        if (win.document) {
            win.document.write(
                '<html><head><title>' +
                    title +
                    '</title></head><body><img src="' +
                    environment.disclosureUrl +
                    '/' +
                    'contact_us_text.gif' +
                    '" width="70%"></body></html>'
            );
        }
        win.focus();
    }
    websiteMoreInfoClick() {
        window.open('https://www.cardiovascular.abbott', '_blank');
    }
}
